import { useQuery } from "@apollo/client";
import { Query, vodabucksBalanceGQL } from "@onmo/graphql/graphql";

export const useVodabucksBalance = (userId?: string) => {
  const { data: vodabucksData } = useQuery<Query["vodabucksBalance"]>(
    vodabucksBalanceGQL,
    {
      variables: { input: { userId: userId || "" } },
    },
  );

  return { vbBalance: vodabucksData?.balance ?? 0 };
};
